import React, { Component } from "react";
import posed from "react-pose";
import ReactGA from "react-ga";

const Pulse = posed.div({
  attention: {
    scale: 1.5,
    transition: {
      duration: 120,
      loop: 2,
      flip: 1,
      ease: "easeInOut"
    }
  }
});
class Nav extends Component {
  render() {
    // Create nav bar items
    const NavItems = () => {
      return this.props.navData.links.map((link, i) => {
        // put new tag if its new
        if (link.new) {
          return (
            <li className="nav-item" key={i}>
              <a className="nav-link text-white scrolling" href={link.href}>
                {link.name} <sup className="text-danger">new</sup>
              </a>
            </li>
          );
        } else {
          return (
            <li className="nav-item" key={i}>
              <a className="nav-link text-white scrolling" href={link.href}>
                {link.name}
              </a>
            </li>
          );
        }
      });
    };

    return (
      <div>
        {/* /LOADER TEMPLATE */}
        <nav className="main-nav navbar navbar-expand-lg fixed-top navbar-light">
          <a className="navbar-brand" href="/synthcity">
            <img
              className="logo-default"
              src="assets/img/default-logo.png"
              alt="Synth City Sojisoft Logo"
            />
            <img
              className="logo-dark"
              src="assets/img/logo-dark.png"
              alt="Synth City Sojisoft Logo Dark"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse m-auto" id="navbarNav">
            <ul className="navbar-nav ml-auto">
              <NavItems />
              <Pulse pose={this.props.attention} onPoseComplete={this.props.onAnimationComplete}>
                <li className="nav-item">
                  <a
                    className="nav-link text-white scrolling btn-call-to-action"
                    target="_blank"
                    href={this.props.navData.callToAction.href}
                    onClick={() => {
                      ReactGA.event({
                        category: "engagement",
                        action: "directToAlpha",
                        value: 1
                      });

                      ReactGA.event({
                        category: "conversion",
                        action: "Signed Up to synthCity Alpha",
                        label: "synthCity Alpha Button",
                        value: 1
                      });
                    }}>
                    {this.props.navData.callToAction.name}{" "}
                  </a>
                </li>
              </Pulse>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/synthcity/Nav.js